// extracted by mini-css-extract-plugin
module.exports = {"dark":"Layout-module--dark--1BkQI","layout":"Layout-module--layout--3Pyz6"};